import React from "react";

export default function Logo({ size = "md" }) {
  const sizes = {
    sm: { text: "text-xl", sub: "text-[9px]" },
    md: { text: "text-2xl", sub: "text-[10px]" },
    lg: { text: "text-3xl sm:text-4xl", sub: "text-[11px]" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="leading-tight" data-testid="brand-logo">
      <div className={`font-heading font-extrabold tracking-tight ${s.text}`}>
        <span className="text-slate-900">Dear</span>
        <span style={{ color: "#1E5FD8" }}>Dr</span>
      </div>
      <div className={`${s.sub} font-semibold uppercase tracking-[0.18em] text-slate-500`}>
        Care &middot; Connect &middot; Lead
      </div>
    </div>
  );
}
